import React from 'react';
import './styles.scss';
import { EditAltIcon } from 'cokitchen-icons';
import { StreakType } from 'utils/types';

type Props = {
  items: StreakType[];
  onSelectAll: () => void;
  onEdit: () => void;
  onDone: () => void;
};

const StreaksActionBox = (props: Props) => {
  const { items, onSelectAll, onEdit, onDone } = props;

  return (
    <div className='streaks-action-box'>
      <p className='text-sm text-[#595959]'>
        {items.length} {items.length > 1 ? 'items' : 'item'} selected
      </p>

      <div className='flex items-center gap-2'>
        <button
          onClick={onSelectAll}
          className='flex items-center gap-1 rounded-lg text-[#595959] [&_svg]:fill-[#595959] text-xs px-3 py-2'>
          Select all
        </button>
        <button
          className='flex items-center gap-1 rounded-lg bg-[#F5F5F5] text-[#595959] [&_svg]:fill-[#595959] text-xs px-3 py-2'
          onClick={onEdit}>
          <EditAltIcon />
          Edit
        </button>
      </div>

      <button className='done-button' onClick={onDone}>
        Done
      </button>
    </div>
  );
};

export default StreaksActionBox;
